'use strict';
import * as $j_com$002eraquo$002elaminar$002ekeys$002e$002dKey from "./com.raquo.laminar.keys.-Key.js";
import * as $j_com$002eraquo$002elaminar$002ekeys$002e$002dSvg$002dAttr$0024 from "./com.raquo.laminar.keys.-Svg-Attr$.js";
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_Lcom_raquo_laminar_keys_SvgAttr(localName, codec, namespacePrefix) {
  this.z6 = null;
  this.z5 = null;
  this.v9 = null;
  this.va = null;
  this.z6 = localName;
  this.z5 = codec;
  var this$2 = (namespacePrefix.k() ? $j_java$002elang$002e$002dObject.$m_s_None$() : new $j_java$002elang$002e$002dObject.$c_s_Some(((namespacePrefix.C() + ":") + localName)));
  this.v9 = (this$2.k() ? localName : this$2.C());
  this.va = (namespacePrefix.k() ? $j_java$002elang$002e$002dObject.$m_s_None$() : new $j_java$002elang$002e$002dObject.$c_s_Some($j_com$002eraquo$002elaminar$002ekeys$002e$002dSvg$002dAttr$0024.$m_Lcom_raquo_laminar_keys_SvgAttr$().Wd(namespacePrefix.C())));
}
export { $c_Lcom_raquo_laminar_keys_SvgAttr as $c_Lcom_raquo_laminar_keys_SvgAttr };
$p = $c_Lcom_raquo_laminar_keys_SvgAttr.prototype = new $j_com$002eraquo$002elaminar$002ekeys$002e$002dKey.$h_Lcom_raquo_laminar_keys_Key();
$p.constructor = $c_Lcom_raquo_laminar_keys_SvgAttr;
/** @constructor */
function $h_Lcom_raquo_laminar_keys_SvgAttr() {
}
export { $h_Lcom_raquo_laminar_keys_SvgAttr as $h_Lcom_raquo_laminar_keys_SvgAttr };
$h_Lcom_raquo_laminar_keys_SvgAttr.prototype = $p;
var $d_Lcom_raquo_laminar_keys_SvgAttr = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lcom_raquo_laminar_keys_SvgAttr, "com.raquo.laminar.keys.SvgAttr", ({
  im: 1,
  a6: 1
}));
export { $d_Lcom_raquo_laminar_keys_SvgAttr as $d_Lcom_raquo_laminar_keys_SvgAttr };
